

















































































































































import {Component, Vue, Watch, Prop} from "vue-property-decorator"
import {namespace} from "vuex-class"
import {Route} from "vue-router"
import {TranslateResult} from "vue-i18n"
import TestAlert from "@/components/UI/TestAlert.vue";
import selectLocale from '@/components/beta/Localiztion/SelectLocale.vue';
import TooltipSimple from "@/components/UI/TooltipSimple.vue";
import WorkspacesList from '@/components/beta/Workspace/WorkspacesList.vue'
import ISetting from '@/components/icons/ISetting.vue'
import {baseUrl} from "@/service/ApiClient";

/*const auth = namespace("auth")*/
const profile = namespace("profile")
const app = namespace("app")
const event = namespace('event')
const roistat = namespace('roistat')
const newauth = namespace('newauth')
const dialog = namespace('dialog')
const workspace = namespace('workspace')


@Component({
  name: 'Toolbar',
  components: {
    TooltipSimple,
    TestAlert,
    selectLocale,
    WorkspacesList,
    ISetting,
  }
})
export default class ToolbarFull extends Vue {
  @event.Getter('shows') protected shows: any

  @Prop({type: Boolean, default: false}) protected hideSearch!: boolean

  protected title: TranslateResult = ''

  @newauth.Action('logout') protected logout: any
  @app.Mutation('SetShowSbToggle') protected SetShowSbToggle: any
  @app.Getter('GetShowSb') protected GetShowSb: any

  @profile.Getter('getUser') protected getUser: any
  @profile.Getter('getCurrentWorkspace') protected getCurrentWorkspace: any
  @profile.Getter('getCurrentCompany') protected getCurrentCompany: any

  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Mutation('SetTopAlert') protected SetTopAlert: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any


  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any
  @workspace.Action('getUserShowFromServer') protected getUserShowFromServer: any
  @workspace.Action('getCompanyShowFromServer') protected getCompanyShowFromServer: any
  @workspace.Mutation('setCurrentExhibition') protected setCurrentExhibition: any


  /*@auth.State("show") protected _show: any
  @auth.Action('logout') protected authLogout: any*/
  //@event.Mutation('clear') protected clear: any
  @roistat.Action('sendEvent') protected sendEvent: any
  baseURL: any = baseUrl()
  dropdownMenuState: boolean = false
  name: string = ''
  lastname: string = ''
  workspace: string = ''
  currentRoute: any = ''
  user: any = {}

  async mounted() {
    if (!this.getCurrentExhibition || !this.getCurrentExhibition.code) {
      if(this.$route.name != 'Corporate' && this.$route.name != 'Personal') {
        if (this.workspace == 'personal') {
          await this.getUserShowFromServer()
        } else {
          await this.getCompanyShowFromServer(
            {
              CompanyCode: this.workspace,
              onlyWithUserParticipation: this.getCurrentCompany.role === 'standman'
            })
        }
      }
    }
    this.setCurrentExhibition(this.$route.params.showCode)
    if (this.getCurrentExhibition && this.getCurrentExhibition.companyParticipation && (this.getCurrentExhibition.companyParticipation.plan == 'free' || this.getCurrentExhibition.companyParticipation.status == 'waiting_payment') && (+new Date() / 1000).toFixed() < this.getCurrentExhibition.end ) {
      this.SetTopAlert(true)
    }
    this.user = this.getUser
  }

  protected showSideBar() {
    alert('boom')
  }

  editProfile() {
    this.SetTitleDialog(this.$t('newProfile.edit_profile'))
    this.SetFormSDialog('EditProfileForm')
    this.SetFullDialogShow(true)
  }

  companySettings() {
    this.$router.push({name: 'CompanySettings', params: {companyCode: this.$route.params.code}}).catch(() => {})
  }


  protected goProfile() {
    this.$router.push({name: 'Profile'}).catch(() => {
    })
    let params = [
      {
        "name": "Переход в “Профиль”",
        /*"data": {
          "company": this.userCompany.title
        }*/
      }
    ]
    this.sendEvent(params)
  }

  /*protected tryLogout() {
    this.authLogout()
      .then(() => {
        this.$router.push({name: 'Auth'}).catch(()=>{})
        this.clear()
      })
      .catch(() => {
      })
  }*/

  @Watch('$route', {immediate: true})
  protected onRouteChange(route: Route) {
    switch (route.name) {
      case 'Personal':
        this.title = 'toolbar.workspace'
        break
      case 'Corporate':
        this.title = 'toolbar.workspace'
        break
      case 'Settings':
        this.title = 'toolbar.settings'
        break
      case 'Statistics':
        this.title = 'toolbar.statistics'
        break
      case 'Shards':
        this.title = 'toolbar.shCommon'
        break
      case 'MailingList':
        this.title = 'mailing.config.leadfrog.mailing'
        break
        // case 'Standmans':
        //   this.title = 'toolbar.standmans'
        //   break
        // case 'Profile':
        //   this.title = 'toolbar.profile'
        //   break


      default:
        this.title = ''
    }
  }

  created() {
    window.addEventListener('click', (e) => {
      let elem = e.target as HTMLElement
      if(elem.closest('.v-dialog') == null && elem.closest('.v-menu__content') == null) {
        this.dropdownMenuState = false
      }
    })
    this.workspace = this.$route.params.code
    this.currentRoute = this.$route.name
  }
}
